"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.canWarehouseManager = exports.ProductAccessKeys = exports.IProductAccess = exports.IProductIDs = exports.IAppIdType = exports.IProductsID = exports.IAppPermissions = exports.appToDefaultAppName = exports.UserDefaultApp = exports.AppName = void 0;
const openapi_1 = require("../../../openapi");
const AppAccess_1 = __importDefault(require("../../../shared/utils/AppAccess"));
var AppName;
(function (AppName) {
    AppName["HUB"] = "Hub";
    AppName["BILLING"] = "Billing";
    AppName["TPL_WAREHOUSE_MANAGER"] = "3PLWarehouseManager";
    AppName["ORDER_MANAGER"] = "OrderManager";
    AppName["NETWORK_MANAGER"] = "NetworkManager";
    AppName["INTEGRATION_MANAGER"] = "IntegrationManager";
    AppName["WAREHOUSE_MANAGER_CLASSIC_ADMIN"] = "WarehouseManagerClassicAdmin";
    AppName["WAREHOUSE_MANAGER_UNLIMITED_ADMIN"] = "WarehouseManagerUnlimitedAdmin";
    AppName["WAREHOUSE_MANAGER_CUSTOMER_PORTAL"] = "WarehouseManagerCustomerPortal";
    AppName["WAREHOUSE_MANAGER_INTEGRATIONS"] = "WarehouseManagerIntegrations";
    AppName["WAREHOUSE_MANAGER_MOBILE"] = "WarehouseManagerMobile";
    AppName["WAREHOUSE_MANAGER_ACCOUNT_MANAGER"] = "WarehouseManagerAccountManager";
    AppName["SIGNUP"] = "Signup";
    AppName["MANAGEMENT_CONSOLE"] = "ManagementConsole";
    AppName["ADMIN"] = "Admin";
    AppName["FM"] = "FulfillmentMarketplace";
    AppName["SMART_SCAN"] = "SmartScan";
    AppName["ACCOUNTING_INTEGRATION"] = "AccountingIntegration";
    AppName["BUSINESS_ANALYTICS"] = "BusinessAnalytics";
})(AppName = exports.AppName || (exports.AppName = {}));
/** @deprecated renamed to AppName */
exports.UserDefaultApp = AppName;
exports.appToDefaultAppName = {
    [AppAccess_1.default.can3pl]: AppName.TPL_WAREHOUSE_MANAGER,
    [AppAccess_1.default.canOrderManager]: AppName.ORDER_MANAGER,
    [AppAccess_1.default.canBilling]: AppName.BILLING,
    [AppAccess_1.default.canNetworkManager]: AppName.NETWORK_MANAGER,
    [AppAccess_1.default.canWarehouseManagerClassicAdmin]: AppName.WAREHOUSE_MANAGER_CLASSIC_ADMIN,
    [AppAccess_1.default.canWarehouseManagerUnlimitedAdmin]: AppName.WAREHOUSE_MANAGER_UNLIMITED_ADMIN,
    [AppAccess_1.default.canWarehouseManagerCustomerPortal]: AppName.WAREHOUSE_MANAGER_CUSTOMER_PORTAL,
    [AppAccess_1.default.canWarehouseManagerIntegrations]: AppName.WAREHOUSE_MANAGER_INTEGRATIONS,
    [AppAccess_1.default.canWarehouseManagerMobile]: AppName.WAREHOUSE_MANAGER_MOBILE,
    [AppAccess_1.default.canWarehouseManagerAccountManager]: AppName.WAREHOUSE_MANAGER_ACCOUNT_MANAGER,
    [AppAccess_1.default.canIntegrationManager]: AppName.INTEGRATION_MANAGER,
    [AppAccess_1.default.canSignUp]: AppName.SIGNUP,
    [AppAccess_1.default.canManagementConsole]: AppName.MANAGEMENT_CONSOLE,
    [AppAccess_1.default.canAdmin]: AppName.ADMIN,
    [AppAccess_1.default.canFM]: AppName.FM,
    [AppAccess_1.default.canSmartScan]: AppName.SMART_SCAN,
    [AppAccess_1.default.canAccountingIntegration]: AppName.ACCOUNTING_INTEGRATION,
    [AppAccess_1.default.canBusinessAnalytics]: AppName.BUSINESS_ANALYTICS,
};
class IAppPermissions {
    perms;
    fplperms;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: { type: 'string' } })
], IAppPermissions.prototype, "perms", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: { type: 'string' } })
], IAppPermissions.prototype, "fplperms", void 0);
exports.IAppPermissions = IAppPermissions;
class IProductsID {
    tplId;
    tplGuid;
    warehouseManagerCustomerID;
    integrationManagerAccountID;
    orderManagerCompanyID;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IProductsID.prototype, "tplId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid', description: 'ID from 3W' })
], IProductsID.prototype, "tplGuid", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', description: 'ID from WM' })
], IProductsID.prototype, "warehouseManagerCustomerID", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', description: 'ID from IM' })
], IProductsID.prototype, "integrationManagerAccountID", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', description: 'ID from OM' })
], IProductsID.prototype, "orderManagerCompanyID", void 0);
exports.IProductsID = IProductsID;
class IAppIdType {
    name;
    id;
    disabled;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IAppIdType.prototype, "name", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IAppIdType.prototype, "id", void 0);
__decorate([
    (0, openapi_1.Schema)({
        type: 'boolean',
    })
], IAppIdType.prototype, "disabled", void 0);
exports.IAppIdType = IAppIdType;
// export class ITplIdType extends IAppIdType {
//     @Schema({ type: 'string', format: 'uuid', description: 'ID from 3W' })
//     guid!: string;
// }
class IProductIDs {
    // @Optional()
    // @Schema({ type: 'array', items: ref(() => ITplIdType) })
    // tplIds?: ITplIdType[];
    // @Optional()
    // @Schema({ type: 'array', items: ref(() => IAppIdType) })
    // wmIds?: IAppIdType[];
    imIds;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IAppIdType) })
], IProductIDs.prototype, "imIds", void 0);
exports.IProductIDs = IProductIDs;
class IProductAccess {
    can3pl;
    canOrderManager;
    canWarehouseManagerClassicAdmin;
    canWarehouseManagerUnlimitedAdmin;
    canWarehouseManagerCustomerPortal;
    canWarehouseManagerIntegrations;
    canWarehouseManagerMobile;
    canWarehouseManagerAccountManager;
    canIntegrationManager;
    canBilling;
    canNetworkManager;
    canSignUp;
    canManagementConsole;
    canAdmin;
    canFM;
    canSmartScan;
    canAccountingIntegration;
    canBusinessAnalytics;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access 3pl Warehouse Manager?',
    })
], IProductAccess.prototype, "can3pl", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access Order Manager Web?',
    })
], IProductAccess.prototype, "canOrderManager", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access Warehouse Manager Classic Admin?',
    })
], IProductAccess.prototype, "canWarehouseManagerClassicAdmin", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access Warehouse Manager Unlimitedd Admin?',
    })
], IProductAccess.prototype, "canWarehouseManagerUnlimitedAdmin", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access Warehouse Manager Customer Portal?',
    })
], IProductAccess.prototype, "canWarehouseManagerCustomerPortal", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access Warehouse Manager Integrations?',
    })
], IProductAccess.prototype, "canWarehouseManagerIntegrations", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access Warehouse Manager Mobile?',
    })
], IProductAccess.prototype, "canWarehouseManagerMobile", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access Warehouse Manager Account Manager?',
    })
], IProductAccess.prototype, "canWarehouseManagerAccountManager", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access Integration Manager?',
    })
], IProductAccess.prototype, "canIntegrationManager", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean', description: 'Can this Org access Billing?' })
], IProductAccess.prototype, "canBilling", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access Network Manager?',
    })
], IProductAccess.prototype, "canNetworkManager", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access 3pl Warehouse Manager Sign Up?',
    })
], IProductAccess.prototype, "canSignUp", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access Management Console?',
    })
], IProductAccess.prototype, "canManagementConsole", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean', description: 'Can this Org access Admin?' })
], IProductAccess.prototype, "canAdmin", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean', description: 'Can this Org access Fulfilment?' })
], IProductAccess.prototype, "canFM", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean', description: 'Can this Org access SmartScan?' })
], IProductAccess.prototype, "canSmartScan", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access Accounting Integration?',
    })
], IProductAccess.prototype, "canAccountingIntegration", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'Can this Org access Business Analytics?',
    })
], IProductAccess.prototype, "canBusinessAnalytics", void 0);
exports.IProductAccess = IProductAccess;
// The purpose of this object is so that ProductAccessKeys below always has every key of IProductAccess
// if IProductAccess is updated, typescript will force us to update this as well
const productAccess = {
    can3pl: false,
    canOrderManager: false,
    canWarehouseManagerClassicAdmin: false,
    canWarehouseManagerUnlimitedAdmin: false,
    canWarehouseManagerCustomerPortal: false,
    canWarehouseManagerIntegrations: false,
    canWarehouseManagerMobile: false,
    canWarehouseManagerAccountManager: false,
    canIntegrationManager: false,
    canBilling: false,
    canNetworkManager: false,
    canSignUp: false,
    canManagementConsole: false,
    canAdmin: false,
    canFM: false,
    canSmartScan: false,
    canAccountingIntegration: false,
    canBusinessAnalytics: false,
};
exports.ProductAccessKeys = Object.keys(productAccess);
function canWarehouseManager(productAccess) {
    return (productAccess?.canWarehouseManagerClassicAdmin ||
        productAccess?.canWarehouseManagerCustomerPortal ||
        productAccess?.canWarehouseManagerIntegrations ||
        productAccess?.canWarehouseManagerUnlimitedAdmin ||
        productAccess?.canWarehouseManagerMobile);
}
exports.canWarehouseManager = canWarehouseManager;
